module.exports = __webpack_public_path__ + "img/local-7.3f89b2b9.jpg";